"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickPromotionRewardType = exports.HumanReadableLocationForPromotion = exports.PromotionCancelledReason = exports.promotionStatusAttributes = exports.PromotionStatus = exports.PromotionName = void 0;
/* @TranslateToPython @TranslateToEnum */
var PromotionName;
(function (PromotionName) {
    PromotionName["freeAmazonPrime"] = "freeAmazonPrime";
    PromotionName["amazonTenDollarCredit"] = "amazonTenDollarCredit";
    PromotionName["amazonTwentyFiveDollarCredit"] = "amazonTwentyFiveDollarCredit";
    PromotionName["taxPaymentCredit"] = "taxPaymentCredit";
    PromotionName["costcoFreeMembership"] = "costcoFreeMembership";
    PromotionName["restaurants7Percent"] = "restaurants7Percent";
    PromotionName["amazonPrime"] = "amazonPrime";
    PromotionName["gasAndGroceries7Percent"] = "gasAndGroceries7Percent";
    PromotionName["threePercentCbOnUpTo100k"] = "threePercentCbOnUpTo100k";
    /**
     * A sign on bonus (i.e. statement credit) applied when a UCC card, originated through the /bundle
     * landing page, is activated.
     */
    PromotionName["uccBundleActivationSignOnBonus"] = "uccBundleActivationSignOnBonus";
    /**
     * A sign-on bonus applied to a UCC/MOAP card on activation after upgrading from Advisor
     */
    PromotionName["starbucksStatementCreditSignOnBonus"] = "starbucksStatementCreditSignOnBonus";
    /**
     * A $400 statement credit for Bigger Pockets Pro members. Customers enter via a dedicated link;
     * the credit is contingent on a Pro-membership API check performed at payout (built separately).
     */
    PromotionName["biggerPocketsProMembershipStatementCredit"] = "biggerPocketsProMembershipStatementCredit";
})(PromotionName || (exports.PromotionName = PromotionName = {}));
var PromotionStatus;
(function (PromotionStatus) {
    PromotionStatus["notEnrolled"] = "notEnrolled";
    /** For upgrade, a UCC user can be put in this status and will move to "previousActivated"
     * if they click on an upgrade ad associated with this promotion.  */
    PromotionStatus["previousEnrolled"] = "previousEnrolled";
    /** For a home upgrade user to get enrolled in a promotion, its previousLoanApplicationId must be found in the table at this status.
     * This would mean that the user's pre-upgrade UCC account "activated" the promotion, so that the home account can get enrolled in the promotion once originated. */
    PromotionStatus["previousActivated"] = "previousActivated";
    PromotionStatus["isEnrolled"] = "isEnrolled";
    PromotionStatus["conditionsFulfilled"] = "conditionsFulfilled";
    PromotionStatus["activatedByCustomer"] = "activatedByCustomer";
    PromotionStatus["promotionPaid"] = "promotionPaid";
    /**
     * The promotion will not be processed. If in this status, quick_promotion table will include
     * a PromotionCancelledReason too.
     */
    PromotionStatus["cancelled"] = "cancelled";
})(PromotionStatus || (exports.PromotionStatus = PromotionStatus = {}));
exports.promotionStatusAttributes = {
    [PromotionStatus.notEnrolled]: { isTerminal: false },
    [PromotionStatus.previousEnrolled]: { isTerminal: false },
    [PromotionStatus.previousActivated]: { isTerminal: false },
    [PromotionStatus.isEnrolled]: { isTerminal: false },
    [PromotionStatus.conditionsFulfilled]: { isTerminal: false },
    [PromotionStatus.activatedByCustomer]: { isTerminal: false },
    [PromotionStatus.promotionPaid]: { isTerminal: true },
    [PromotionStatus.cancelled]: { isTerminal: true },
};
var PromotionCancelledReason;
(function (PromotionCancelledReason) {
    /** The cardholders account was closed, so we cannot provide the promotion. */
    PromotionCancelledReason["accountIsClosed"] = "accountIsClosed";
    /** The recheck window elapsed without the eligibility conditions being met, so we stop re-attempting. */
    PromotionCancelledReason["eligibilityPeriodExpired"] = "eligibilityPeriodExpired";
})(PromotionCancelledReason || (exports.PromotionCancelledReason = PromotionCancelledReason = {}));
var HumanReadableLocationForPromotion;
(function (HumanReadableLocationForPromotion) {
    HumanReadableLocationForPromotion["orangeCounty"] = "Orange County";
    HumanReadableLocationForPromotion["arizona"] = "Arizona";
    HumanReadableLocationForPromotion["phoenix"] = "Phoenix";
    HumanReadableLocationForPromotion["ohio"] = "Ohio";
    HumanReadableLocationForPromotion["cleveland"] = "Cleveland";
    HumanReadableLocationForPromotion["denver"] = "Denver";
    HumanReadableLocationForPromotion["tampa"] = "Tampa";
})(HumanReadableLocationForPromotion || (exports.HumanReadableLocationForPromotion = HumanReadableLocationForPromotion = {}));
var QuickPromotionRewardType;
(function (QuickPromotionRewardType) {
    /** Quick Promotions that pay a one-time bonus as a statement credit to the enrolled customer when they claim the promotion */
    QuickPromotionRewardType["ONE_TIME_BONUS"] = "ONE_TIME_BONUS";
    /** Quick Promotions that enroll a customer's aven card holder account feature spec in a boost cash back name when they claim the promotion */
    QuickPromotionRewardType["BOOST_REWARDS"] = "BOOST_REWARDS";
    /** Quick Promotions that pay a one-time bonus as a statement credit to the enrolled customer once the customer has both claimed the promotion and made a specific purchase */
    QuickPromotionRewardType["ONE_TIME_BONUS_CONTINGENT_ON_PURCHASE"] = "ONE_TIME_BONUS_CONTINGENT_ON_PURCHASE";
})(QuickPromotionRewardType || (exports.QuickPromotionRewardType = QuickPromotionRewardType = {}));
